module.exports = __webpack_public_path__ + "img/ic_update.81f2ee2e.svg";